module.exports = __webpack_public_path__ + "static/media/tolaram.7d0c8576.svg";